export default [

     {
          path: '/vendor-repository',
          name: 'VendorRepository',
          component: () => import("@/views/Page/VendorRepository/VendorRepository.vue"),
           meta: {
               title: 'VendorRepository',
          },
     }
];